import { render, staticRenderFns } from "./ModelPostalDataSection.vue?vue&type=template&id=2f8cb96d"
import script from "./ModelPostalDataSection.vue?vue&type=script&lang=js"
export * from "./ModelPostalDataSection.vue?vue&type=script&lang=js"
import style0 from "./ModelPostalDataSection.vue?vue&type=style&index=0&id=2f8cb96d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports